<template>
  <div class>
    <section class="d-flex flex-column h-full">
      <!-- <div class="fixed-header w-full"> -->
      <TopAppBar
        :leftBtnMode="leftBtnMode"
        :rightBtnMode="rightBtnMode"
        :title="title"
        :leftBtnMethod="leftBtnMethod"
        :rightBtnMethod="rightBtnMethod"
        staticMode="true"
      ></TopAppBar>
      <TopAppBarDrawer
        :isDrawerOpen="isDrawerOpen"
        @closeDrawer="closeDrawer"
      ></TopAppBarDrawer>
    </section>
    <!-- 상단 고정 캠페인 배너 -->
    <div
      v-if="
        campaignData &&
        campaignData.dynamicLink &&
        campaignData.locationValue === null
      "
    >
      <a :href="campaignData.dynamicLink.shortLink" target="_blank">
        <img :src="campaignData.image" :alt="campaignData.dynamicLink.name" />
      </a>
    </div>

    <NoData v-if="isNoData"></NoData>

    <div class="pdt-16 pdb-20">
      <div
        v-for="(list, index) in listData"
        :key="index"
        class="d-flex border-bottom pdt-16 pdb-16 pdl-16 pdr-16 bg-white"
        @click="moveToDetail(list.id)"
      >
        <div class="placeholder">
          <img src="images/certificateicon.svg" alt="" class="profile" />
        </div>
        <div class="rewardCardContent">
          <p
            class="t-color-title l-spacing48 t-body1 pdr-16 pdl-16 mgb-1 mgt-1"
          >
            {{ list.name }}
          </p>
          <p
            v-if="list.params.ISSUE_DATE"
            class="t-color-content1 l-spacing48 t-helper pdr-16 pdl-16 mgt-1 mgb-1"
          >
            {{
              $t("1721", {
                str: $moment
                  .unix(list.params.ISSUE_DATE / 1000)
                  .format("YYYY. MM. DD"),
              })
            }}
          </p>
        </div>
      </div>

      <infinite-loading
        @infinite="fetchData"
        :identifier="infiniteId"
        spinner="spiral"
      >
        <div slot="no-more" class="mgt-16"></div>
        <div slot="no-results" class="mgt-16"></div>
      </infinite-loading>
    </div>
  </div>
</template>

<script>
/**
 * 나의 학습 목록 메인 컴포넌트(my learning main list component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import { MDCRipple } from "@material/ripple";
import rewardApi from "@/api/rewardApi.js";
import campaignApi from "@/api/campaignApi.js";
//import ListItem from "./ListItem.vue";
import NoData from "../common/NoDataCertificateList.vue";
import InfiniteLoading from "vue-infinite-loading";
import TopAppBar from "@/components/TopAppBar.vue";
import { topAppBarMixin } from "@/mixins/topAppBar.js";
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";

export default {
  name: "CertificateList",
  components: {
    TopAppBar,
    //ListItem,
    NoData,
    InfiniteLoading,
    TopAppBarDrawer,
  },
  filters: {
    convertDate(valu) {
      var date = new Date(valu);
      return date.toString("MMM dd");
    },
  },
  data() {
    return {
      status: "",
      isNoData: false,
      campaignData: null,
      listData: [],
      currentPage: 1,
      totalPages: 1,
      mine: "",
      myStatus: "",
      infiniteId: +new Date(),
      isDrawerOpen: false,
    };
  },

  computed: {},

  watch: {
    $route(to, from) {
      this.initData();
      this.myStatus = this.$route.query.status;
    },
  },
  mixins: [topAppBarMixin],
  mounted() {
    this.leftBtnMode = "menu";
    this.leftBtnMethod = this.openDrawer;
  },

  methods: {
    initData() {
      this.listData = [];
      this.currentPage = 1;
      this.totalPages = 1;
      this.infiniteId += 1;
    },
    // 목록 데이터 로딩(get list data)
    fetchData($state) {
      let responseData = null;
      let params = this.setParams();
      console.log("params", params);
      if (this.totalPages >= this.currentPage) {
        rewardApi
          .rewardCertificateList(params)
          .then((response) => {
            responseData = response.data.data;
            console.log("responseData=>", responseData);
            // this.mine = responseData.mine;

            this.listData = this.listData.concat(responseData.content);
            console.log("listData=>", this.listData);
            this.currentPage++;
            this.totalPages = responseData.totalPages;

            if (responseData.length) {
              $state.loaded();
            } else {
              $state.complete();
            }

            if (this.listData.length > 0) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          })
          .catch((err) => {
            $state.error();
          });
      } else {
        $state.complete();
      }

      // 캠페인 테이터 API 호출(get campaign data)
      let locationType =
        this.$route.query.status === "LEARNING"
          ? "LEARN_IN_PROGRESS_DEGREE"
          : "LEARN_COMPLETED_DEGREE";
      campaignApi
        .campaign({ locationType: locationType })
        .then((response) => {
          this.campaignData = response.data.data;
        })
        .catch((err) => {});
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        //status: this.$route.query.status,
        // name: "",
        // category: "",
        page: this.currentPage,
        size: 10,
        sort: "id,desc",
      };
      return params;
    },
    moveToDetail(id) {
      console.log("certificateId=>", id);
      this.$router.push("/certificatedetail/" + id);
    },
    // 학습진행률 노출 상태 설정(set/toggle learning status graph)
    initProgressStatus(id) {
      _.map(this.listData, (o) => {
        o.id === id && o.progressViewStatus === false
          ? (o.progressViewStatus = true)
          : (o.progressViewStatus = false);
      });
    },
    openDrawer() {
      this.isDrawerOpen = true;
    },
    closeDrawer() {
      this.isDrawerOpen = false;
    },
  },
};
</script>

<style scoped>
.mdc-elevation--z3 {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}

.rewardTitle {
  font-size: 16px;
}
.crown160 {
  max-width: 160px;
}
.shadow135 {
  max-width: 135px;
  height: 30px;
}
.border-bottom {
  border-bottom: 1px solid #f1f1f1;
}
.rewardCardContent {
  width: calc(100% - 100px);
}
</style>